import { Form } from 'factorial-form'

import type Field from 'modules/reports/store/models/Field'

interface FilterOptions {
  selected: Field[]
  search: string
}

class FilterForm extends Form {
  constructor(values: {}) {
    super(values, {
      filterBy: 'any', // Since this can contain different criteria
    })
  }

  applyFilters(
    fields: Field[],
    { selected, search }: FilterOptions = {
      selected: [],
      search: '',
    }
  ): Field[] {
    const paths = new Set(selected.map((f: Field) => f.attributes.path))

    return fields.filter((f: Field) => !paths.has(f.attributes.path) && f.matchLabels(search))
  }
}

export default FilterForm
